
import {
    Box, TextField, FormControl, InputAdornment, InputLabel, Input, IconButton, Button,
    Typography, Select, MenuItem, FormHelperText, Alert, Divider
} from '@mui/material';
import { AccountCircleOutlined, Visibility, VisibilityOff, LockOutlined, Group } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch, } from 'react-redux';
import { set } from 'lodash';
import { Tabs } from '../../components/tabs';
import { Grid } from '../../components/table';
import { CONFIG } from '../../../config'
import axios from 'axios';
import { ToolBar } from '../../components/toolbar';
import { Modal } from '../../components/modal';
import { FormA } from '../../components/form';
import moment from 'moment';
import { getFormState } from '../../../helpers/form';
import dayjs from 'dayjs';
import { SelectA, FileUploadA, DatePickerA } from '../../components/form';

import {Fields}  from './fields';
import {CampaignList} from './list';
const API_HOST = CONFIG.modules['accounts'].host


const items = {
    'Fields': {
        name: 'Fields',
        view: ({active})=> (<Fields active={active}/>)
    },
    'Campaigns': {
        name: 'Campaigns',
        view: ({active})=> (<Fields active={active}/>)
    },
    'CampaignForms': {
        name: 'Campaign Forms',
        view: ({active})=> (<Fields active={active}/>)
    },
  

}

const markStyle = { borderRadius: 1,ml: 2, minWidth: 300, background: '#F3D55B',mb: 3 ,height:40, pl:2, display:'flex', alignItems:'center' }

const wrap = { display: 'flex', alignItems: 'center', justifyContent:'space-between' }
const text2 = {fontSize: '.8em'}

export const Campaigns = (props) => {
    const { roles, user, users, Designations, Departments, Languages, Districts, Campaigns } = useSelector((state) => (state.user || {}))

    const [active, setActive] = useState('Fields')
 


    return (
        <>
            <Tabs items={items} active={active} onChange={(key) => {
                setActive(key)
            }} />
            {
                items[active]&& items[active].view &&
                items[active].view({active})
            }

        </>
    )
}